if (!window.featuredCollectionSwiperInitialized) {

  window.featuredCollectionSwiperInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    const collectionSliders = document.querySelectorAll('.featured-collection__contents');

    collectionSliders.forEach(function (slider) {

      if (slider.classList.contains('swiper-initialized')) return;

      const sectionId = slider.classList.value.match(/featured-collection-(.*?)\-js/)[1];

      new Swiper(slider, {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 8,
        pagination: {
          el: slider.querySelector('.swiper-pagination-col'),
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-next-${sectionId}-js`,
          prevEl: `.swiper-prev-${sectionId}-js`,
          enabled: false,
        },
        breakpoints: {
          980: {
            loop: false,
            spaceBetween: 22,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: false,
            },
          }
        }
      });

    });
  });

}